import client from './client';

/**
 * Initialize CMSD values for a pipeline
 * @param {string} pipelineId - Pipeline UUID
 * @returns {Promise<Object>} Initialized CMSD values
 */
export const initializeCMSD = async (pipelineId) => {
  const response = await client.post(`/api/pipelines/${pipelineId}/cmsd/initialize`);
  return response.data;
};

/**
 * Get current CMSD state for a pipeline
 * @param {string} pipelineId - Pipeline UUID
 * @returns {Promise<Object>} Current CMSD state with formatted headers
 */
export const getCMSDState = async (pipelineId) => {
  const response = await client.get(`/api/pipelines/${pipelineId}/cmsd`);
  return response.data;
};

/**
 * Set CMSD state for a pipeline
 * @param {string} pipelineId - Pipeline UUID
 * @param {string} state - New state: "good", "bad", or "demo-scenario"
 * @returns {Promise<Object>} Updated CMSD state
 */
export const setCMSDState = async (pipelineId, state) => {
  const response = await client.post(`/api/pipelines/${pipelineId}/cmsd/state`, { state });
  return response.data;
};

/**
 * Set custom headers for a pipeline
 * @param {string} pipelineId - Pipeline UUID
 * @param {Object} headers - Dictionary of header name -> value
 * @returns {Promise<Object>} Updated CMSD state
 */
export const setCustomHeaders = async (pipelineId, headers) => {
  const response = await client.post(`/api/pipelines/${pipelineId}/cmsd/custom-headers`, headers);
  return response.data;
};
